// Title screen
import { GFX } from '../core/graphics';
import { drawTitleParts } from '../kit';
import { SFX } from '../core/audio';
import { t } from '../core/i18n';
import { $ } from './dom';
import { G, show } from './state';
import { setI } from './icons';
import { Store } from '../core/store';
import { fakeBall } from './intro';
import { renderProfiles } from './profiles';

// ---------- Title ----------
export function drawTitle() {
  const c = $<HTMLCanvasElement>('#titleCanvas'), x = c.getContext('2d')!;
  x.setTransform(2, 0, 0, 2, 0, 0); x.clearRect(0, 0, 520, 150);
  const t = G.t;
  drawTitleParts(x, t, GFX);
  const k = (t % 180) / 180;
  let bx: number, by: number;
  if (k < 0.45) { const kk = k / 0.45; bx = 50 + kk * 205; by = 58 + kk * 44; }
  else if (k < 0.62) { const kk = (k - 0.45) / 0.17; bx = 255 + kk * 110; by = 102 + kk * kk * 8; }
  else { const kk = (k - 0.62) / 0.38; bx = 365 + kk * 105; by = 104 - Math.sin(kk * Math.PI) * 70 + kk * 20; }
  const fb = fakeBall(bx, by, 5, k > 0.62 && k < 0.8 ? -6 : 3, 16); fb.roll = bx / 16; if (k > 0.9) return; GFX.ball(x, fb, 'hero', t);
}

$('#logo').innerHTML = t('app.name').split('').map((c, i) => `<span style="animation-delay:${i * 0.12}s">${c}</span>`).join('');
setI($('#startBtn'), 'play');
$('#startBtn').addEventListener('click', () => {
  SFX.init(); SFX.set('sound', Store.d.settings.sound); SFX.set('music', Store.d.settings.music); SFX.play('start');
  renderProfiles(); show('scrProfiles');
});
